/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

// dispatch function for tab data for request Invoices qtr not paid screen
export const invoicesQtrnotPaidObj = (data) => ({
  type: actionTypes.GET_INV_QTR_NOT_PAID_DISPLAY_OBJ,
  screenData: data,
});

// dispatch function for tab data for Display Invoices qtr not paid screen
export const invoicesQtrnotPaidDetailObj = (data) => ({
  type: actionTypes.GET_INV_QTR_NOT_PAID_DETAIL_OBJ,
  detailScrData: data,
});

// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

// To get plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};

//  get rebate programe funnction
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};

//  error msg dispatch function
export const dispatchErrorMsgInvQtrnotPaid = (data) => ({
  type: actionTypes.GET_ERROR_MSG_INV_QTR_NOT_PAID,
  payload: data,
});

// Loader
export const setLoading = (value) => ({
  type: actionTypes.IS_LOADING,
  isLoading: value,
});
// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  setTimeout(() => {
    dispatch(dispatchDisplayInputField({ errorMsgQtrlyPayment: [] }));
  }, 5000);
  dispatch(
    dispatchDisplayInputField({
      errorMsgQtrlyPayment: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

// get Inv Qtr not Paid data on Search dispatch function
export const dispatchInvoiceQtrnotPaidData = (data) => ({
  type: actionTypes.GET_INVOICE_QTR_NOT_PAID_DATA,
  payload: data,
});

// To get Inv Qtr not Paid data on search
export const getInvoiceQuarternotPaid = (value, value2) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_INVOICE_QTR_NOT_PAID_DATA, value)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(
        dispatchInvoiceQtrnotPaidData({
          data: response.data,
          value2: value2,
        })
      );
    })
    .catch(() => {
      dispatch(setLoading(false));
      dispatch(dispatchInvoiceQtrnotPaidData([]));
    });
};
// Display screen input field

export const dispatchDisplayInputField = (data) => ({
  type: actionTypes.DISPLAY_INV_QTR_NOT_PAID_INPUT_FIELD,
  payload: data,
});

// dispatch quarter value function
export const dispatchMaxQuarterValue = (data) => ({
  type: actionTypes.GET_REBATE_QUARTER_VALUE,
  payload: data,
});

//  get quarter value data
export const getMaxQuarterValue = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_QTR_FOR_INV_NOT_PAID, value)
    .then((response) => {
      return response.data;
      // return dispatch(dispatchMaxQuarterValue(response.data));
    })
    .catch((response) => {
      return [];
      // dispatch(dispatchMaxQuarterValue([]));
    });
};

// Invoice api call

export const dispatchInvoiceDetailsByInvoiceNum = (data) => ({
  type: actionTypes.GET_INVOICE_DETAILS_BY_INVOICE_NUM,
  payload: data,
});

export const getInvoiceDetailsByInvoiceNum = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_INVOICE_DETAILS_BY_INVOICE_NUM, values)
    .then((response) => {
      dispatch(dispatchInvoiceDetailsByInvoiceNum(response.data));
    });
};
// Refresh Tab
export const refreshInvQtrnotPaidTab = (payload) => {
  return {
    type: actionTypes.REFRESH_INVOICE_QTR_NOT_PAID,
    payload: {},
  };
};
// rebate programe dispatch function
export const refreshInvQtrnotPaidTabDisplay = () => ({
  type: actionTypes.REFRESH_INVOICE_QTR_NOT_PAID_DISPLAY,
  payload: {},
});

// rebate programe dispatch function
export const setExtraStateForInvoiceForQtrNotPaid = (val) => ({
  type: actionTypes.SET_INVOICE_FOR_QTR_NOT_PAID_EXTRA_STATE,
  extraState: val,
});
export const resetInvoiceQtrNotPaidState = () => ({
  type: actionTypes.RESET_INVOICE_QTR_NOT_PAID,
});

export const clearReduxInvoiceQtr = () => (dispatch) => {
  dispatch(resetInvoiceQtrNotPaidState()); 
};
